module.exports = __webpack_public_path__ + "static/media/manual-screen-5.982fd4c9.png";